import React, { useEffect, useRef, useState } from "react";
import { motion, useAnimation } from "framer-motion"; 
import frame1 from "../../assets/frame1.png";
import frame2 from "../../assets/frame2.png";
import frame3 from "../../assets/frame3.png";


const imageFrames = [frame1, frame2, frame3];

const titles = [
  "Food Pro'24 Expo - Nov'24",
  "India Food Pack Show - Sep'24",
  "Compack Complete Expo - Aug'24",
];
const PastEvent = () => {

    
  const initialWidth = 200;
  const [widths, setWidths] = useState([
    initialWidth,
    initialWidth,
    initialWidth,
  ]);
  const [activeIndexPast, setActiveIndexPast] = useState(2);

  const calculateWidths = (clickedIndex) => {
    return imageFrames.map((_, index) => {
      const distance = Math.abs(index - clickedIndex);
      if (distance === 0) return 450;
      if (distance === 1) return 250;
      return 45; // others small
    });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setWidths(calculateWidths(activeIndexPast));
    }, 1000);
    return () => clearTimeout(timeout);
  }, []);

  const handleClickPast = (index) => {
    setActiveIndexPast(index);
    setWidths(calculateWidths(index));
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "50px",
          padding: "20px",
        }}
      >
        {imageFrames?.map((img, index) => (
          <motion.div
            key={index}
            onClick={() => handleClickPast(index)}
            initial={{ opacity: 0, x: 100 }}
            animate={{
              opacity: 1,
              x: 0,
              width: widths[index],
            }}
            transition={{
              opacity: { delay: index * 0.3, duration: 0.5 },
              x: { delay: index * 0.3, duration: 0.5 },
              width: { duration: 0.8 },
            }}
            style={{
              height: "230px", // ✅ SAME HEIGHT for all images
              borderRadius: "20px",
              overflow: "hidden",
              position: "relative",
              boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
              backgroundColor: "white",
              flexShrink: 0,
              cursor: "pointer",
            }}
          >
            <img
              src={img}
              alt={`event ${index}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: 10,
                left: 10,
                color: "#fff",
                fontWeight: "bold",
                fontSize: "12px",
                textShadow: "0 0 4px rgba(0,0,0,0.7)",
                width: "90%",
              }}
            >
              {titles[index]}
            </div>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default PastEvent;
